import React from 'react';
import './WhychooseusSession.css';
import { FaHandshake, FaGlobeAmericas } from 'react-icons/fa';

function WhychooseusSession() {
  return (
    <div className="whychooseus-session">
      <div className="whychooseus-background"></div>
      <div className="whychooseus-content">
        <div className="whychooseus-header">
          <p className='whychooseus-tital'>WHY CHOOSE US ?</p>
          <p className='whychooseus-content-p'>We take immense pride in being the preferred choice for all your shipping needs. With an extensive global network and a seamless logistical infrastructure, we offer unparalleled access to international markets, allowing your cargo to reach its destination effortlessly.</p>
        </div>
        
        <div className="whychooseus-features">
          <div className="feature-item">
            <div className="feature-icon">
              <FaHandshake />
            </div>
            <div className="feature-text">
              <h3>An International Network Of Efficient Partners</h3>
              <p>Centrex marine services Shipping keeps itself abreast of the international business practices and trade regulations of the region which helps it provide hassle-free solutions to its web of clients.</p>
            </div>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon">
              <FaGlobeAmericas />
            </div>
            <div className="feature-text">
              <h3>A Reliable National Web</h3>
              <p>With Centrex marine services Shipping's head office situated in the city of Karachi, our web of offices cover all major cities of Pakistan which are run by trained staff and sales representatives as well as hand-picked associates at all ports and airports in the country.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhychooseusSession;
